import { CSSProperties } from "react";

const commonList: CSSProperties = {
  padding: 0,
  flexGrow: 1,
  overflowY: "auto",
};

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "80%",
    height: "83vh",
    margin: "0 auto",
  },
  titleArea: {
    marginBottom: 3,
  },
  title: {
    fontSize: 30,
  },
  paper: {
    padding: 2,
    flex: 1,
    height: "calc(100vh - 350px)",
    display: "flex",
    flexDirection: "column",
  },
  paperSearchWrapper: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "white",
  },
  paperList: {
    marginTop: 0,
    ...commonList,
  },
  paperListUser: {
    borderTop: "none",
    ...commonList,
  },
  paperTitle: {
    borderTop: "solid 1px #ddd",
    paddingTop: 1,
  },
  buttonArea: {
    borderTop: "solid 1px #ddd",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 1,
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 1,
    cursor: "pointer",
  },
  listItemUser: {
    marginBottom: 1,
    padding: 1,
    cursor: "default",
  },
  userStack:{
    width: "100%",
    justifyContent: "space-between"
  },
  menuItem: {
    padding: 2,
    cursor: "pointer"
  },
  selectedItem: {
    backgroundColor: "#03a696",
    color: "white",
    borderRadius: 2,
  },
};
